// extracted by mini-css-extract-plugin
export var navbar = "Navbar-module--navbar--3_1C0";
export var navItemActive = "Navbar-module--navItemActive--2I4T2";
export var navItem = "Navbar-module--navItem--1mo1M";